import React from 'react';
import util from 'Utils/commonUtil';
import {connect} from 'react-redux';

//Components
import Anchor from 'Components/common/Anchor';
import BasicButton from 'Components/common/BasicButton';
import ProductImage from 'Components/commonOrder/ProductImage';

// Actions
import {T} from 'Actions/translate';
import {openNotification} from 'Actions/notification';
import copy from 'copy-to-clipboard';
import {loadLanguage} from 'Utils/jwtUtil';
// Icons
import {NavigateNext, Timer} from '@material-ui/icons';

class MyOrderItem extends React.Component {
    statusList = {
        '-1': T('user_center_canceled'),
        1: T('to_send_the_goods'),
        3: T('wait_for_receiving'),
        4: T('have_been_signed'),
    };

    /**
     * Get title text
     */
    getTitleText = (item) => {
        if ((item.status === 1 || item.status === 2) && !item.partialDelivery)
            return T('pending_orders');
        if ((item.status === 1 || item.status === 2) && item.partialDelivery)
            return T('Shipped_order') + '-' + T('part_of_the_shipment');
        if (item.status === 3)
            return T('Shipped_order') + '-' + T('all_shipments');
        if (item.status === 4) return T('received_order');
        if (item.status === -1 && !item.partialCanceled)
            return T('cancelled_order');
        if (item.status === -1 && item.partialCanceled)
            return T('partial_cancelled_order');
    };

    isPartShipped = (item) =>
        (item.status === 1 || item.status === 2) && item.partialDelivery;
    isAllShipped = (item) => item.status === 3;
    isCancel = (item) => item.status === -1 && !item.partialCanceled;
    isPartialCancel = (item) => item.status === -1 && item.partialCanceled;

    chooseItem = (item, ev) => {
        if (util.isFunction(this.props.chooseItem))
            this.props.chooseItem(item, ev);
    };

    getQuantity = (products) => {
        let quantity = 0;

        products &&
            products.forEach((product) => {
                quantity += product.quantity;
            });

        return quantity;
    };

    copyContent = (text) => {
        copy(text);
        this.props.openNotification(T('notification_copy_success'), 'success');
    };

    getEoneHoldLockTypes = (lockType) => {
        const originalLockType = util.getLockedTypeOriginalValue(lockType);
        if (!originalLockType) {
            return [];
        }

        return originalLockType
            .split('&')
            .map((item) => item.trim())
            .filter(Boolean);
    };

    render() {
        const {item, options, localData} = this.props;
        let title = this.getTitleText(item);
        let lang = loadLanguage();
        const eoneHoldLockTypes = this.getEoneHoldLockTypes(item.lockType);
        let showTitle = options ? options.showTitle : false;
        let showReceiveBtn =
            options && util.isBoolean(options.showReceiveBtn)
                ? options.showReceiveBtn
                : true;
        let showBuyAgainBtn =
            options && util.isBoolean(options.showBuyAgainBtn)
                ? options.showBuyAgainBtn
                : true;
        let isShipped = false;

        // Check shipments is shipped
        item.orderProducts &&
            item.orderProducts.forEach((product) => {
                if (product.shippedQuantity > 0) isShipped = true;
                item.id === 698 && console.log(isShipped);
            });

        return (
            <li
                className="my-order-item"
                key={item.id}
                testid="customer-order-card"
                data-order-no={item.number}
                data-eone-number={item.eoneNumber}>
                <Anchor
                    onClickOfSingleTap={this.chooseItem.bind(this, item)}
                    testid="customer-order-detail-btn">
                    {title &&
                    showTitle &&
                    (item.webOrderType === 'CR' ||
                        item.webOrderType === 'SE') ? (
                        <h6 className="my-order-item-title">
                            <span className="ready-payment-style">
                                {T('advance_payment')}
                            </span>
                            <span className="title-style">{title}</span>
                        </h6>
                    ) : title && showTitle ? (
                        <h6 className="my-order-item-title">
                            <span className="title-style">{title}</span>
                        </h6>
                    ) : item.webOrderType === 'CR' ||
                      item.webOrderType === 'SE' ? (
                        <h6 className="my-order-item-title">
                            <span className="ready-payment-style">
                                {T('advance_payment')}
                            </span>
                        </h6>
                    ) : null}

                    <p
                        className={
                            item.haveShippingPlan
                                ? 'order-id desc clearfix order-have-shipping-plan'
                                : 'order-id desc clearfix'
                        }>
                        {item.haveShippingPlan ? <Timer /> : null}
                        {T('order_number')}
                        <span className="value">{item.number}</span>
                        <BasicButton
                            className="copy"
                            onClickOfSingleTap={() =>
                                this.copyContent(item.number)
                            }
                            isStopPropagation={true}>
                            {T('copy')}
                        </BasicButton>
                    </p>
                    {localData.roleType === 3 ? (
                        <React.Fragment>
                            <p className="lab-or-dept desc">
                                {T('order_subject')}{' '}
                                <span className="value">{item.labOrDept}</span>
                            </p>
                            <p className="ship-to-num desc">
                                {T('order_ship_to_number')}{' '}
                                <span className="value">{item.shipToNum}</span>
                            </p>
                        </React.Fragment>
                    ) : null}
                    <p className="order-time desc">
                        {T('order_purchase_date')}{' '}
                        <span className="value">{item.createTime}</span>
                    </p>
                    <p
                        className={`eone-number desc ${
                            util.getLockedTypeOriginalValue(item.lockType) ===
                            ''
                                ? 'eone-bottom'
                                : ''
                        }`}>
                        {T('order_eone_number')}
                        <span className="value">{item.eoneNumber}</span>
                        <BasicButton
                            type="primary"
                            className="copy"
                            onClickOfSingleTap={() =>
                                this.copyContent(item.eoneNumber)
                            }
                            isStopPropagation={true}>
                            {T('copy')}
                        </BasicButton>
                    </p>
                    {eoneHoldLockTypes.length > 0 ? (
                        <p className={'eone-hold desc eone-bottom'}>
                            {T('order_eone_hold')}{' '}
                            <span className="value eone-hold-tags">
                                {eoneHoldLockTypes.map((lockType, index) => (
                                    <span
                                        className="eone-hold-tag"
                                        key={`${lockType}-${index}`}>
                                        {lockType}
                                    </span>
                                ))}
                            </span>
                        </p>
                    ) : null}
                    <section className="my-order-detail">
                        <ul className="image-list">
                            {item.orderProducts &&
                                item.orderProducts.map((p, index) => {
                                    if (index > 2) return null;

                                    return (
                                        <li key={p.id}>
                                            <ProductImage
                                                src={
                                                    p.product &&
                                                    p.product.productPic
                                                }
                                                alt={
                                                    p.product &&
                                                    p.product.productName
                                                }
                                                key={
                                                    p.product &&
                                                    p.product.productPic
                                                }
                                            />
                                        </li>
                                    );
                                })}
                        </ul>
                        <p className="quantity desc">
                            {T('shippment_total_pieces', [
                                this.getQuantity(item.orderProducts),
                            ])}
                            <NavigateNext />
                        </p>
                    </section>
                    <p className="price-box">
                        <span className="desc">{T('order_total_amount')}</span>
                        <b className="price price-font">
                            <i className="rmb"></i>{' '}
                            <span className="price-number">
                                {item.totalPrice
                                    ? util.toMoney(item.totalPrice)
                                    : '0.00'}
                            </span>
                        </b>
                    </p>
                    <div className="btn-box clearfix">
                        {item.orderType === 'SCM' && item.status === 1 ? (
                            <BasicButton
                                type="primary"
                                className="my-order-onhold-btn pull-right"
                                testid="my_order_list_onhold_btn"
                                onClickOfSingleTap={options.orderOnHoldInfo}
                                isStopPropagation={true}>
                                {T('my_order_on_hold')}
                            </BasicButton>
                        ) : null}
                        {showBuyAgainBtn &&
                        item.orderProducts &&
                        item.orderProducts.length > 0 &&
                        util.isShowBtn(item.orderProducts) ? (
                            <BasicButton
                                className="buy-again-btn pull-right"
                                testid="my_order_list_buy_again_btn"
                                type="primary"
                                onClickOfSingleTap={options.buyAgain}
                                isStopPropagation={true}>
                                {T('order_buy_again')}
                            </BasicButton>
                        ) : null}
                        {showReceiveBtn && isShipped ? (
                            <BasicButton
                                className="receipt-btn pull-right"
                                testid={
                                    item.partialDelivery
                                        ? 'my_order_list_partial_receipt_btn'
                                        : 'my_order_list_full_receipt_btn'
                                }
                                type="primary"
                                onClickOfSingleTap={options.receiveOrder}
                                isStopPropagation={true}>
                                {item.partialDelivery
                                    ? T('order_partial_receipt')
                                    : T('order_full_receipt')}
                            </BasicButton>
                        ) : null}
                        {item.orderType === 'SCM' ? (
                            <BasicButton
                                type="primary"
                                className="delivery-infor pull-right"
                                testid="my_order_list_delivery_infor_btn"
                                onClickOfSingleTap={options.deliverInfor}
                                isStopPropagation={true}>
                                {T('shippment_delivery_details')}
                            </BasicButton>
                        ) : null}
                    </div>
                    {options && options.showTag ? (
                        <div
                            testid="my_order_list_tag"
                            className={util.getClassName({
                                tag: true,
                                'part-shipped':
                                    this.isPartShipped(item) && lang !== 'EN',
                                shipped:
                                    this.isAllShipped(item) && lang !== 'EN',
                                'is-cancel':
                                    this.isCancel(item) && lang !== 'EN',
                                'is-partial-cancel':
                                    this.isPartialCancel(item) && lang !== 'EN',
                                'is-TFS':
                                    item.orderType === 'TFS' && lang !== 'EN',
                                checking:
                                    util.getLockedType(item) === 'checking' &&
                                    lang !== 'EN',
                                'is-lock':
                                    util.getLockedType(item) ===
                                        'financialLocked' && lang !== 'EN',
                                'is-adding-c2-lock':
                                    util.getLockedType(item) ===
                                        'addingC2Locked' && lang !== 'EN',
                                'en-part-shipped':
                                    this.isPartShipped(item) && lang === 'EN',
                                'en-shipped':
                                    this.isAllShipped(item) && lang === 'EN',
                                'en-is-cancel':
                                    this.isCancel(item) && lang === 'EN',
                                'en-is-partial-cancel':
                                    this.isPartialCancel(item) && lang === 'EN',
                                'en-is-TFS':
                                    item.orderType === 'TFS' && lang === 'EN',
                                'en-checking':
                                    util.getLockedType(item) === 'checking' &&
                                    lang === 'EN',
                                'en-is-lock':
                                    util.getLockedType(item) ===
                                        'financialLocked' && lang === 'EN',
                                'en-is-adding-c2-lock':
                                    util.getLockedType(item) ===
                                        'addingC2Locked' && lang === 'EN',
                            })}></div>
                    ) : null}
                </Anchor>
            </li>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData} = state;

    return {
        localData,
    };
};

const mapDispatchToProps = {
    openNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyOrderItem);
